module.exports = __webpack_public_path__ + "media/images/application/template/arrow-right-c3712632860d57e9baa674f912da6e02.svg";